$(function () {
  var square = function (elem) {
    if($(window).outerWidth() < 768) {
      $(elem).css('height','');
    } else {
      $(elem).each(function () {
        $(this).css('height',$(this).width());
      })
    }
  }

  square('.timeline-event > .year-box');
  $(window).on('resize',function (e) {
    square('.timeline-event > .year-box');
  })
})
